// extracted by mini-css-extract-plugin
export var optionGrid = "_5y-7";
export var optionList = "_5y-6";
export var questionsBlock = "_5y-9";
export var spacer = "_5y-5";
export var stepCenteredContent = "_5y-3";
export var stepInner = "_5y-0";
export var stepInnerFullWidth = "_5y-1";
export var stepInnerLockScroll = "_5y-2";
export var stepTransitionFrame = "_5y-4";
export var welcomeBlock = "_5y-8";